import styled from 'styled-components'

export const CardWrapper = styled.div`
 background: white;
 margin-bottom: ${props => props.lastElement ? 0 : '1rem'};

${props => props.disabled && `
  opacity: .4;
`}

 @media (min-width:768px){
  margin-right: ${props => props.lastElement ? 0 : '1rem'};
 }



`